import styled from 'styled-components';

export const NotificationContainerDiv = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.8rem;
    justify-content: center;
    background-color: ${({ theme }) => theme.color.grey1};
    border-bottom: 0.1rem solid ${({ theme }) => theme.color.grey3};

    > div[class*='spinner'] {
        margin-inline: unset;
    }
`;
